import { useSelector } from "react-redux";
import ChartListItem from "./ChartListItem";

function SizeChartsList() {
    const sizeCharts = useSelector((state) => state.inventoryManagement.sizeCharts.sizeCharts);

    return (
        <div className="w-full flex flex-col border border-[#EAEAEA] rounded-lg">
            <div className="w-full rounded-tl-lg rounded-tr-lg flex items-center py-2 bg-[#F5F5F5] text-[16px] leading-8 text-[#666666] font-semibold">
                <div className="w-[70%] px-[10px] py-2">
                    <p>Size Charts</p>
                </div>

                <div className="w-[calc(30%-44px)] px-[10px] py-2">
                    <p>Sizes</p>
                </div>
                
                <div className="size-11"></div>
            </div>

            {sizeCharts.map((sizeChart, index) => {
                let isLast = index === sizeCharts.length - 1;

                return (
                    <ChartListItem 
                        key={sizeChart.id} 
                        sizeChart={sizeChart} 
                        isLast={isLast} 
                    />
                )
            })}
        </div>
    )
}

export default SizeChartsList;
